import Vue from "vue"
import App from "./App.vue"
import "./registerServiceWorker"
import router from "./router"
import store from "./store"
import vuetify from "./plugins/vuetify"
import Moment from "moment"
import VueSession from "vue-session"
import IdleVue from "idle-vue"
import VueIziToast from "vue-izitoast"
import "izitoast/dist/css/iziToast.min.css"
import {
  _HASPERMISSION,
  _ISALLOWED,
  _ISDISABLED,
  _ISSUPER
} from "./store/_PERMISSIONS"
import VueCookies from "vue-cookies"
Vue.config.productionTip = false

// -- GLOBAL VARIABLES

Vue.prototype.$eventBus = new Vue()
Vue.prototype.$toastPosition = "topRight"
Vue.prototype.$toastTimeout = "3000"
Vue.prototype.$loadTimeout = 1000
Vue.prototype.$files = process.env.VUE_APP_API + "/hemaapi/api"
Vue.prototype.$moment = Moment

Vue.prototype.$_HASPERMISSION = _HASPERMISSION
Vue.prototype.$_ISALLOWED = _ISALLOWED
Vue.prototype.$_ISDISABLED = _ISDISABLED
Vue.prototype.$_ISSUPER = _ISSUPER

Vue.prototype.$cotas = "12.00"

Vue.prototype.$success = "Operação efetuada com sucesso!"
Vue.prototype.$error = "Ocorreu um erro ao efetuar a operação!"

// -- DEPENDENCIES

var options = {
  persist: true
}
Vue.use(VueSession, options)

const eventBus = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventBus,
  idleTime: 3600000
})

Vue.use(VueIziToast)
Vue.use(VueCookies)

// -- COLORS

Vue.prototype.$primary = "#E53935"

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  onIdle() {
    this.$eventBus.$emit("logout")
  }
}).$mount("#app")
